import React from 'react';
import { Select, Divider, Input, Button } from 'antd';
import { connect } from 'react-redux';
import { requestServerPost, selectPage, requestNodeServerPost, requestServerGet } from '../actions';
import { PlusCircleFilled } from '@ant-design/icons';
import PopupManager from '../managers/PopupManager';
import StringHelper from '../helpers/StringHelper';

const { Option } = Select;

class CampaignSelector extends React.Component {

    constructor(props) {
        super(props);
        this.state = { campaigntDatas: [], campaignOptions: [] }
    }

    componentDidMount() {
        this.reloadPlaylists();
    }

    reloadPlaylists = () => {

        const { usertoken, requestServerGet, selectedBrandData } = this.props;

        requestServerGet("get_campaigns", { brandid: selectedBrandData.BrandID }, null, (response) => {
            const options = response.data.map(data => {
                return { value: data.CampaignID, label: data.CampaignName }
            })

            // options.unshift({ value: 0, label: "Create New Playlist" })
            this.setState({ campaigntDatas: options, campaignOptions: options })
        }, usertoken)
    }

    filter = (inputValue, path) => {
        return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    }

    onChange = (value, selectedOptions) => {
        const { onChange } = this.props;
        onChange(value, selectedOptions);
    }

    onSearch = (value) => {

        console.log('search:', value);
    }
    onNameChange = event => {
        // this.setState({
        //     newPlaylistName: event.target.value,
        // });
    };

    render() {
        const { value, onSelect, defaultValue, getPopupContainer } = this.props;
        return (
            <Select
                value={(value === -1 || value === undefined) ? undefined : String(value)}
                showSearch
                filterOption={StringHelper.SELECT_SEARCH_FILTER_LABEL_OPTION}
                onSelect={onSelect}
                defaultValue={defaultValue}
                style={{ width: 300, borderRadius: "4px" }}
                placeholder="Select Campaign"
                getPopupContainer={getPopupContainer}
                dropdownRender={menu => (
                    <div>
                        {menu}
                    </div>
                )}
            >
                {this.state.campaignOptions.map(item => (
                    <Option key={item.value} value={String(item.value)}>{item.label}</Option>
                ))}
            </Select>
        )
    }
}

const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData, selectedBranchData: state.selectedBranchData };
}

export default connect(mapStateToProps, { requestServerGet, requestServerPost, selectPage, requestNodeServerPost })(CampaignSelector);